import { render, staticRenderFns } from "./Combinados.vue?vue&type=template&id=52080fbe&scoped=true&"
import script from "./Combinados.vue?vue&type=script&lang=js&"
export * from "./Combinados.vue?vue&type=script&lang=js&"
import style0 from "./Combinados.vue?vue&type=style&index=0&id=52080fbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52080fbe",
  null
  
)

export default component.exports